import * as React from 'react';
const SvgClockDashedQuarter = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={20}
    height={20}
    fill="none"
    viewBox="0 0 20 20"
    {...props}
  >
    <path
      fill="currentColor"
      d="M10.017 2.675a.75.75 0 0 1-.671.824 6.517 6.517 0 1 0 7.155 7.156.751.751 0 1 1 1.495.154 8.02 8.02 0 1 1-8.803-8.805.75.75 0 0 1 .824.67m1.022-.066a.75.75 0 0 1 .905-.556q.57.136 1.106.35a.751.751 0 1 1-.556 1.396 6.6 6.6 0 0 0-.9-.285.75.75 0 0 1-.555-.905m6.557 4.34a.751.751 0 0 0-1.396.556q.175.435.285.9a.751.751 0 0 0 1.462-.35 8 8 0 0 0-.35-1.106m-3.28-3.053a.75.75 0 0 1 1.06-.073q.463.401.86.869a.751.751 0 1 1-1.144.973 7 7 0 0 0-.702-.709.75.75 0 0 1-.073-1.06M10.02 5.723a.751.751 0 0 0-1.502 0v5.009c0 .415.336.751.751.751h3.005a.751.751 0 1 0 0-1.502H10.02z"
    />
  </svg>
);
export default SvgClockDashedQuarter;
